module.exports = __webpack_public_path__ + "img/icon-addonetether-02.svg";